import { getFunctionnalErrorMessage } from 'components/secondaryMarket/dlpOrder/sidePanel/rejected/utils';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import {
  getOrderId,
  getOrderRejections,
  getOrderTimeout,
  isOrderTimeout,
} from 'state/secondaryMarket/dlpOrder/order/order.selector';
import { secondaryMarketDlpOrderPlacementRequestedThunk } from 'state/secondaryMarket/dlpOrder/order/order.thunks';
import { getIsUserInternal } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<{
  isInternalUser: boolean;
  errorMessage: string | null;
  timeout?: number;
  hasTimeout: boolean;
  orderId?: string;
}>;

type DispatchProps = Readonly<{
  onPlaceOrder: () => void;
}>;

export type RejectedOrderSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps: (state: AppState, ownProps: OwnProps) => StateProps = (state, { tabId }) => {
  const rejections = getOrderRejections(state, tabId)!;
  const timeout = getOrderTimeout(state, tabId)!;
  const isInternalUser = getIsUserInternal(state);
  const hasTimeout = isOrderTimeout(state, tabId) ?? false;
  const orderId = getOrderId(state, tabId);

  return {
    errorMessage: getFunctionnalErrorMessage(rejections),
    timeout,
    isInternalUser,
    hasTimeout,
    orderId,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onPlaceOrder() {
      dispatch(secondaryMarketDlpOrderPlacementRequestedThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Request for place order');
    },
  };
};

export const connectRejectedOrderSidePanel = connect(mapStateToProps, mapDispatchToProps);
